module.exports = __webpack_public_path__ + "img/wheel.40a8fa04.png";